import { ModelCommon, UserAttributeDefs } from "@iotv/datamodel-core";
import { ErrData, Position } from "@iotv/iotv-v3-types";
import {
  convertLineTypePathToArea,
  convertPointTypePathToArea,
  covertLateralPathToArea,
} from "./EffluentSpreader/effluentAreaCalculation";
import { EffluentSpreaderHelper } from "../utilityFns";
const typeName = "EffluentPath";

export enum EFFLUENT_PATH_TYPE {
  LateralEffluentSpreader = "Lateral Effluent Spreader",
  PivotEffluentSpreader = "Pivot Effluent Spreader",
  // TravellingEffluentSpreader = "Travelling Effluent Spreader",
}

export class EffluentPath extends ModelCommon {
  // extends DeviceEnabledType<SupportedDevices> {
  constructor(ob: any) {
    super(ob.type || typeName, ob);
    this.pathType = ob.pathType;
    this.throwDistance = ob.throwDistance;
    this.coverage = ob.coverage;
    this.path = ob.path;
    this.radius = ob.radius;
    this.name = ob.name;

    // ensure the radius is always zero for non-pivots
    // if (ob.pathType === EFFLUENT_PATH_TYPE.TravellingEffluentSpreader) {
    //   this.radius = 0;
    // }

    if (ob.pathType === EFFLUENT_PATH_TYPE.PivotEffluentSpreader) {
      if (ob.radius === 0 && ob.throwDistance !== 0) {
        this.radius = ob.throwDistance / 2;
        this.throwDistance = ob.throwDistance / 2;
      }
    }
  }

  throwDistance: number;
  location?: Position;
  path: Position[];
  pathType: EFFLUENT_PATH_TYPE;
  radius: number;
  coverage: Position[];

  constructPath(points: Position[]) {
    switch (this.pathType) {
      case EFFLUENT_PATH_TYPE.PivotEffluentSpreader:
        if (points.length === 1) {
          this.path = points;
        }
        break;
      case EFFLUENT_PATH_TYPE.LateralEffluentSpreader:
        let potentalMids =
          EffluentSpreaderHelper.convertMidLineForLateral(points);
        if (potentalMids !== undefined) {
          this.path = potentalMids;
        }
        break;
      // case EFFLUENT_PATH_TYPE.TravellingEffluentSpreader:
      //   this.path = points;
      //   break;
      default:
        this.path = points;
        break;
    }
  }

  construstSpreadArea(): ErrData<Position[]> {
    let res: ErrData<Position[]> = { err: null, data: null };
    if (this.path) {
      let coverArea: Position[] | undefined = [];
      let calculatedCover: Position[] | undefined = [];
      switch (this.pathType) {
        case EFFLUENT_PATH_TYPE.PivotEffluentSpreader:
          calculatedCover = convertPointTypePathToArea(
            this.path,
            this.throwDistance,
            this.radius,
          );
          break;
        case EFFLUENT_PATH_TYPE.LateralEffluentSpreader:
          calculatedCover = covertLateralPathToArea(
            this.path,
            this.throwDistance,
            this.radius,
          );
          break;
        // case EFFLUENT_PATH_TYPE.TravellingEffluentSpreader:
        //   calculatedCover = convertLineTypePathToArea(this.path, this.throwDistance);
        //   break;
      }
      if (calculatedCover === undefined) {
        res.err = Error(`${this.pathType} coverage calculation failed`);
      } else {
        coverArea = calculatedCover;
      }

      this.coverage = coverArea;
      return { ...res, data: coverArea };
    } else {
      return { ...res, err: Error("No Path Found") };
    }
  }

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      throwDistance: {
        type: "Number",
        editable: true,
        label: "Throw Radius (m)",
        required: true,
      },
      pathType: {
        type: "Enum",
        enumKv: EFFLUENT_PATH_TYPE,
        editable: true,
        label: "Supported Type",
        name: "type",
        description: "Effluent Run Support Type",
      },
      radius: {
        type: "Number",
        editable: true,
        default: 0,
        label: "Length Span (m)",
        required: true,
      },
    };
  }
}
